var _effectorFileName = "/builds/gmini/front-common/src/components/BaseConditions/PropertyTag.tsx";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import { Cross, Tooltip } from '@gmini/ui-kit';
import { BubbleText, Bubble, CrossWrapper, DeleteButton } from "./PropertyTag.styled";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var PropertyTag = function PropertyTag(_ref) {
  var groupName = _ref.groupName,
      name = _ref.name,
      isNotInList = _ref.isNotInList,
      index = _ref.index,
      getTagProps = _ref.getTagProps,
      readonly = _ref.readonly;

  var onDelete = function onDelete(event) {
    var _getTagProps, _getTagProps$onDelete;

    (_getTagProps = getTagProps({
      index: index
    })) === null || _getTagProps === void 0 ? void 0 : (_getTagProps$onDelete = _getTagProps.onDelete) === null || _getTagProps$onDelete === void 0 ? void 0 : _getTagProps$onDelete.call(_getTagProps, event);
  };

  return /*#__PURE__*/_jsx(Bubble, _objectSpread(_objectSpread({
    error: isNotInList
  }, getTagProps({
    index: index
  })), {}, {
    children: /*#__PURE__*/_jsx(Tooltip, {
      placement: "top",
      title: isNotInList ? 'Свойство отсутствует в дереве' : '',
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs(BubbleText, {
          error: isNotInList,
          readonly: readonly,
          children: [groupName, name && "".concat(groupName && ".").concat(name)]
        }), !readonly && /*#__PURE__*/_jsx(DeleteButton, {
          error: isNotInList,
          onClick: onDelete,
          children: /*#__PURE__*/_jsx(CrossWrapper, {
            children: /*#__PURE__*/_jsx(Cross, {})
          })
        })]
      })
    })
  }));
};